import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

enum CreditTransactionType {
    Deposit = "deposit",
    withdrawal = "withdrawal"
}

export class GetUserCreditTransactionResponse {
    constructor(private id: string, private type: CreditTransactionType, private value: number, private datePaid: Date, private dateCreated: Date){}
}

class Response {
    withdrawals!: GetUserCreditTransactionResponse[];
    deposits!: GetUserCreditTransactionResponse[];
}

export function getUserLatestCreditTransactions(): Promise<AxiosResponse<Response>>{
    const query = '/user/credit-latest-tranactions';
    return Cirus.get(query);
}